/*
 * Copyright (c) 2021. Sanish Manandhar
 * All Rights Reserved
 */

export const TEAM_UPSERT_REQUEST = 'TEAM_ADD_REQUEST';
export const TEAM_UPSERT_REQUEST_SUCCESS = 'TEAM_ADD_REQUEST_SUCCESS';
export const TEAM_UPSERT_REQUEST_FAILURE = 'TEAM_ADD_REQUEST_FAILURE';

export const TEAM_FETCH_REQUEST = 'TEAM_FETCH_REQUEST';
export const TEAM_FETCH_REQUEST_SUCCESS = 'TEAM_FETCH_REQUEST_SUCCESS';
export const TEAM_FETCH_REQUEST_FAILURE = 'TEAM_FETCH_REQUEST_FAILURE';

export const SINGLE_TEAM_FETCH_REQUEST = 'SINGLE_TEAM_FETCH_REQUEST';
export const SINGLE_TEAM_FETCH_REQUEST_SUCCESS = 'SINGLE_TEAM_FETCH_REQUEST_SUCCESS';
export const SINGLE_TEAM_FETCH_REQUEST_FAILURE = 'SINGLE_TEAM_FETCH_REQUEST_FAILURE';

export const TEAM_CLEAN_REQUEST = 'TEAM_CLEAN_REQUEST';
export const TEAM_ERROR_CLEAN_REQUEST = 'TEAM_ERROR_CLEAN_REQUEST';

export const SINGLE_TEAM_CLEAN_REQUEST = 'SINGLE_TEAM_CLEAN_REQUEST';
